import { render, staticRenderFns } from "./Pertenecemos.vue?vue&type=template&id=92fd8776&scoped=true&"
import script from "./Pertenecemos.vue?vue&type=script&lang=js&"
export * from "./Pertenecemos.vue?vue&type=script&lang=js&"
import style0 from "./Pertenecemos.vue?vue&type=style&index=0&id=92fd8776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fd8776",
  null
  
)

export default component.exports